<template>
    <div class="interactive-camera">
        <video ref="player" autoplay muted playsinline></video>
        <div v-if="overlay || text" class="camera-overlay">
            <div class="camera-overlay-image" :style="overlayStyles"></div>
            <div class="camera-overlay-text">
                {{ text }}
            </div>
        </div>
        <button ref="capture" class="btn btn-primary" @click.prevent="take">
            <i class="fa fa-camera"></i>
        </button>
        <canvas ref="canvas" :width="videoWidth" :height="videoHeight" style="visibility:hidden"></canvas>
    </div>
</template>
<script>
    export default {
        props: ['overlay', 'text'],
        emits: ['cancel', 'input'],
        data: function () {
            return {
                isFullscreen: false,
                playerHeight: 0,
                playerWidth: 0,
                screenWidth: 1440,
                videoHeight: 0,
                videoWidth: 0,
            }
        },
        computed: {
            overlayStyles() {
                return { 'background-image': 'url(' + this.overlay + ')', 'max-width': this.playerWidth + 'px' };
            },
            textViewBox() {
                return '0 0 ' + this.screenWidth + ' 32';
            }
        },
        methods: {
            goBack() {
                this.isFullscreen = false;
                if (window.location.hash?.indexOf('fullscreen') > 0) {
                    history.back();
                }
            },
            startFullscreen() {
                if (!document.fullscreenElement && !document.fullscreen) {
                    if (this.$el.requestFullscreen) {
                        this.$el.requestFullscreen();
                    } else { //Safari iOS
                        document.body.classList.add('fullscreen');
                        this.$el.classList.add('fullscreen-element');
                        this.fullscreenChanged();
                    }
                }
            },
            fullscreenChanged() {
                if (!document.fullscreenElement && !document.fullscreen && !document.body.classList.contains('fullscreen')) {
                    if (this.isFullscreen) {
                        this.goBack();
                        this.$emit('cancel');
                    }
                } else {
                    this.isFullscreen = true;
                }
            },
            endFullscreen() {
                if (document.fullscreenElement || document.fullscreen) {
                    document.exitFullscreen && document.exitFullscreen();
                    document.fullscreenElement?.exitFullscreen && document.fullscreenElement.exitFullscreen();
                }
                document.body.classList.remove('fullscreen');
                this.$el.classList.remove('fullscreen-element');
            },
            popState(event) {
                this.endFullscreen();
            },
            take() {
                const vm = this;
                const player = vm.$refs.player;
                const canvas = vm.$refs.canvas;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(player, 0, 0, vm.videoWidth, vm.videoHeight);

                canvas.toBlob((blob) => {
                    const url = URL.createObjectURL(blob);
                    vm.goBack(); //signal we're exiting fullscreen because picture was taken
                    vm.endFullscreen();
                    vm.$emit('input', blob, url);
                });
            }
        },
        mounted() {
            const vm = this;
            const player = vm.$refs.player;
            const constraints = {
                video: {
                    facingMode: { ideal: 'environment' },
                    //Higher resolutions can be requested
                    width: { ideal: 1440 },
                    height: { ideal: 1080 } //4:3
                }
            };

            vm.startFullscreen();

            // Attach the video stream to the video element and autoplay.
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                if ('srcObject' in player) {
                    player.srcObject = stream;
                } else {
                    player.src = window.URL.createObjectURL(stream);
                }
            });


            player.addEventListener('resize', e => {
                vm.videoHeight = player.videoHeight;
                vm.videoWidth = player.videoWidth;
                vm.playerHeight = player.clientHeight;
                vm.playerWidth = player.clientWidth;
            }, false);

            //handle esc button
            vm.$el.addEventListener("fullscreenchange", (event) => {
                vm.fullscreenChanged();
            });

            //handle back button
            window.addEventListener('popstate', e => {
                vm.popState(e);
            });

            window.addEventListener('resize', e => {
                vm.screenWidth = window.screen.width;
            });
        },
        watch: {
            isFullscreen(fs) {
                let isFull = window.location.hash?.indexOf('fullscreen') > 0;
                fs && !isFull && history.pushState(null, '', '#fullscreen');
            }
        }
    }
</script>